<div class="container">
    <img
        alt="Guitar pick"
        class="guitarPick"
        src="../../assets/guitarPick.svg"
    />

    <div class="wrapper">
        <div class="headerContainer">
            <div class="logoWrapper">
                <img
                    class="controlant-logo"
                    src="../../assets/controlant-logo-color.svg"
                />
            </div>
        </div>

        <div class="contentContainer">
            <div class="contentHeader">
                <h4 i18n="Password set success headline@@pwSetSuccessHeadline">Success!</h4>
            </div>
            <div i18n="Password set success text@@pwSetSuccessText">
                <p>
                    Your new password takes effect immediately.
                </p>
            </div>
        </div>
    </div>
</div>
